import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import axios from 'axios'
import './css/style.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import SlideVerify from 'vue-monoplasty-slide-verify';

Vue.config.productionTip = false

Vue.use(Mint);
Vue.use(VueAwesomeSwiper, /* { default global options } */);
Vue.use(SlideVerify);

Vue.prototype.$axios = axios
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
axios.defaults.timeout = 20000
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'


// 请求拦截器
axios.interceptors.request.use(function (config) {

  var token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// http 响应拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          localStorage.removeItem('accessToken');
          var savedUrl = sessionStorage.getItem("HistoryURL");
          if(!savedUrl){
            var url = window.location.href;
            sessionStorage.setItem("HistoryURL", url);
          }
          
          window.location.href = '#/login';
      }
    }
    return Promise.reject(error.response)
  })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 根据路由设置标题
router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next();
})